<script setup>
const props = defineProps({
  propsData: {
    type: [Array, Object],
    default: () => [],
  },
  isMore: {
    default: false,
    type: Boolean,
  },
  rowIndex: {
    default: 0,
    type: Number,
  },
  customShowHide: {
    default: false,
    type: Boolean,
  },
  customIcon: {
    default: {
      customClass: '',
      customCommand: '',
      customText: null,
      customTextCommand: null,
    },
    type: [Object, Boolean],
  },
  dataRow: {
    default: null,
    type: Object,
  },
  // func custom tooltip icon
  customTooltipIcon: {
    type: [Function, Boolean],
    default: null,
  },
  customShortkeyRowAction: {
    type: [Function, Boolean],
    default: null,
  },
  // Thuộc tính để cấu hình có disabled grid hay không
  disabledGrid: {
    default: null,
    type: Boolean,
  },
  // Bổ sung thêm để custom class dựa theo dòng dữ liệu
  customClass: {
    type: [Function, String],
    default: () => {
      return '';
    },
  },
});

/**
 * Thêm tooltip cho icon
 * NXCHIEN 24.07.2022
 * VDDONG 22/08/2024: Bổ sung hàm customTooltipIcon để custom tooltip cho icon nếu cần
 */
const getToolTip = value => {
  //Nếu customTooltipIcon là function thì gọi hàm customTooltipIcon
  if (props.customTooltipIcon) {
    return props.customTooltipIcon(value);
  } else {
    switch (value) {
      case 'Insert':
        return 'Thêm dòng';
      case 'Delete':
        return 'Xóa dòng';
      case 'Edit':
        return 'Sửa dòng';
    }
  }
};

const customClassF = (dataRow, name) => {
  if (props.customClass && typeof props.customClass == 'function') {
    return props.customClass(dataRow, name);
  }
};

const getShortkeyTarget = value => {
  if (props.customShortkeyRowAction) {
    return props.customShortkeyRowAction(value);
  } else {
    switch (value) {
      case 'Insert':
        return $ms.constant.Command.InsertRowGrid;
      case 'Delete':
        return $ms.constant.Command.DeleteRowGrid;
    }
  }
};
</script>

<template>
  <div v-if="customIcon.customText != null" class="cell-action-custom" :class="[{'has-icon': customIcon.customClass != 'display-none'}, customIcon.customTextClass]">
    <div class="custom-text" :title="customIcon.customText" @click="$emit('gridRowActionClick', customIcon.customTextCommand || item, rowIndex)">
      <span class="overflow">{{customIcon.customText}}</span>
    </div>
    <div v-if="customIcon.customClass != 'display-none'">
      <div
        v-for="(item, index) in propsData"
        :key="index"
        v-tooltip="!disabledGrid ? customIcon.toolTip || getToolTip(item) : ''"
        class="row-editor-action"
        :class="[
          item.toString().toLowerCase(),
          {'before-last': index <= propsData.length - 2},
          {'drag-data': item.toString().toLowerCase() === 'drag'},
          {icon24: !customShowHide},
          customIcon.customClass,
          customClassF(dataRow, customIcon.customCommand || item),
        ]"
        @click="$emit('gridRowActionClick', customIcon.customCommand || item, rowIndex)"
      ></div>
    </div>
  </div>
  <div class="cell-action" v-else>
    <div
      v-for="(item, index) in propsData"
      :key="index"
      v-tooltip="!disabledGrid ? customIcon.toolTip || getToolTip(item) : ''"
      class="row-editor-action"
      :class="[
        item.toString().toLowerCase(),
        {'before-last': index <= propsData.length - 2},
        {'drag-data': item.toString().toLowerCase() === 'drag'},
        {icon24: !customShowHide},
        customIcon.customClass,
        customClassF(dataRow, customIcon.customCommand || item),
      ]"
      @click="$emit('gridRowActionClick', customIcon.customCommand || item, rowIndex)"
      shortkey-target="getShortkeyTarget(item)"
    ></div>
  </div>
</template>

<style lang="scss" scoped>
.before-last {
  margin-right: 4px;
}
.drag-data {
  cursor: move;
}

.cell-action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
  height: 100%;
}
.cell-action-custom {
  justify-content: space-between !important;
  display: flex;
  align-items: center;
  padding-right: 10px;
  height: 100%;
  padding-left: 8px;

  .overflow {
    overflow: hidden;
  }
}
.display-none {
  display: none;
}
</style>
